<template>
  <div class="breadcrumb">
    <h2>
      <span class="crumb">
        <router-link :to="{ name: 'trips' }">Dashboard</router-link>
        <span class="icon">></span>
        <router-link :to="{ name: 'trips' }">Trips</router-link>
        <span class="icon">></span>
      </span>
      <span>{{ title }}</span>
      <span v-if="props.trip.customer_name" class="cust">&nbsp;&middot;&nbsp;{{ cust }}</span>
    </h2>
    <div class="identifier">
      <input v-if="!trip.organization_program_id" v-model="identifier" type="text" :class="{ loading: formIsLoading, off: !formIsEdit }" maxlength="50" spellcheck="false" @blur="save" @keyup.enter="save" @click="formIsEdit = true" />
      <span v-else>{{ identifierGroup }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject } from "vue";
import DateTime from "../utils/datetime";

const { utilDateFlightfox } = DateTime();

const props = defineProps({
  trip: Object,
});

const emit = defineEmits(["error"]);

const axios = inject("axios");
const jwt = inject("jwt");

const identifier = ref(props.trip.identifier);
const formIsEdit = ref(false);
const formIsLoading = ref(false);

const title = computed(() => {
  const where = props.trip.destination;
  const when = props.trip.date_start;

  if (!where && !when) {
    return "Trip";
  } else if (!where) {
    return `Trip on ${utilDateFlightfox(when)}`;
  } else if (!when) {
    return `Trip to ${where}`;
  } else {
    return `${where} on ${utilDateFlightfox(when)}`;
  }
});

const cust = computed(() => {
  return props.trip.customer_name;
});

const identifierGroup = computed(() => {
  //return trip.program_identifier, add trip.identifier only if non empty and not numeric
  if (props.trip.identifier && isNaN(props.trip.identifier)) {
    return `${props.trip.program_identifier} (${props.trip.identifier})`;
  }
  return `${props.trip.program_identifier}`;
});

const save = event => {
  if (identifier.value === props.trip.identifier) {
    formIsEdit.value = false;
    event.target.blur();
    return;
  }

  formIsLoading.value = true;

  axios
    .put(
      `${import.meta.env.VITE_APP_FLIGHTFOX_API_URL}/trips/${props.trip.id}/identifier`,
      {
        identifier: identifier.value,
      },
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then(() => {
      formIsEdit.value = false;
      event.target.blur();
    })
    .catch(error => {
      emit("error", error);
    })
    .finally(() => {
      formIsLoading.value = false;
    });
};
</script>

<style lang="less">
#view .breadcrumb {
  input {
    display: flex;
    line-height: 1;
    padding: 0;
    resize: none;
    text-align: right;
    flex-grow: 1;
    white-space: nowrap;

    min-width: 100px; /* Minimum width */
    max-width: 100%; /* Maximum width to prevent overflow */
    overflow: auto; /* Allows scrolling */

    &.off {
      background: transparent;
      border-color: transparent;
      color: @primary;
    }

    &.loading {
      margin: 0;
    }
  }

  .identifier {
    margin-left: 2rem;
    max-width: 40%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .cust {
    display: none;
  }
}

@media screen and (min-width: 60em) {
  #view .breadcrumb .cust {
    display: inline;
  }
}
</style>
